import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MarketService } from "../../../../../../shared/src/lib/services/market.service";
import { NgClass, NgStyle } from "@angular/common";
import { FavoritesService } from "../../../../../../shared/src/lib/services/favorites.service";
import { MatIconModule } from "@angular/material/icon";
import { Subject } from "rxjs";
import { CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray } from "@angular/cdk/drag-drop";
import { MatButtonModule } from "@angular/material/button";
import { SnackbarService } from "../../../../../../shared/src/lib/services/snackbar.service";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-favourites-manager",
  imports: [MatDialogModule, NgClass, NgStyle, MatIconModule, CdkDropList, CdkDrag, MatButtonModule, TranslateModule],
  templateUrl: "./favourites-manager.component.html",
  styleUrl: "./favourites-manager.component.scss",
})
export class FavouritesManagerComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  marketService = inject(MarketService);
  favoritesService = inject(FavoritesService);
  dialogRef = inject(MatDialogRef<FavouritesManagerComponent>);
  snackbar = inject(SnackbarService);
  loader = inject(LoaderService);
  marketItems: any[] = [];
  parents: any[] = [];
  selectedItems: any[] = [];

  ngOnInit() {
    this.fetchSports();
    this.getFavoriteItems();
  }

  getFavoriteItems() {
    this.favoritesService
      .getFavoriteItems()
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        // console.log(value);
        this.selectedItems = value;
      });
  }

  fetchNavItems(type: any, id: any) {
    if (type === "EVENT_TYPE") {
      this.fetchSportTypes(id);
    } else if (type === "GROUP") {
      this.fetchGroups(id);
    } else if (["EVENT", "RACE"].includes(type)) {
      this.fetchEvents(id);
    }
  }

  fetchSports(event?: any) {
    event?.stopPropagation();

    this.marketService
      .getSports()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response?.data?.length > 0) {
            this.marketItems = response?.data;
            this.setParents([]);
          }
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }

  fetchSportTypes(id: string) {
    this.marketService
      .getSportType({ id })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.marketItems = response?.data;
            if (response?.data?.length > 0) this.setParents(response?.data[0]?.parents);
          }
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }

  fetchGroups(id: string) {
    this.marketService
      .getGroup({ id })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.marketItems = response?.data;
            if (response?.data?.length > 0) this.setParents(response?.data[0]?.parents);
          }
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }

  fetchEvents(id: string) {
    this.marketService
      .getEvent({ id })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.marketItems = response?.data;
            if (response?.data?.length > 0) this.setParents(response?.data[0]?.parents);
          }
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }

  isImmediateParent(index: number) {
    return this.parents.length - 1 === index;
  }

  setParents(data: any[]) {
    this.parents = data;
  }

  handleFavorites(item: any, e: Event) {
    e.stopPropagation();
    // console.log(item);
    if (this.isFavorite(item)) {
      this.favoritesService.remove(item, item.type);
    } else {
      this.favoritesService.add(item, item.type);
    }
  }

  isFavorite(item: any) {
    return this.favoritesService.isFavorite(item.id, item.type);
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.selectedItems, event.previousIndex, event.currentIndex);
    this.favoritesService.setFavorites(this.selectedItems);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
